import {addToolImageContent} from "./contentFormatters/formatImageMessage.ts";

const validateToolCallWasCalledByMostRecentAssistant = (formattedMessages: any[], toolCallId: string): boolean => {
    // Iterate backward through the formatted messages to find the most recent assistant message
    for (let i = formattedMessages.length - 1; i >= 0; i--) {
        const message = formattedMessages[i];

        if (message.role === "assistant") {
            // Check if this assistant message has tool_calls that include our tool call ID
            if (message.tool_calls && Array.isArray(message.tool_calls)) {
                const hasToolCall = message.tool_calls.some((toolCall: any) => toolCall.id === toolCallId);
                if (hasToolCall) return true;
            }

            // Also check in the content array for tool_use type
            if (message.content && Array.isArray(message.content)) {
                const hasToolCallInContent = message.content.some((item: any) =>
                    item.type === "tool_use" && item.id === toolCallId
                );
                if (hasToolCallInContent) return true;
            }

            // If we found an assistant message but it doesn't have the tool call ID, return false
            return false;
        }
    }

    // If we didn't find any assistant message, return false
    return false;
};

export const addFormattedToolMessage = async (formattedMessages: any[], currentNode: any, provider: string, addIfFound: any, processedToolCallIds: Set<string>) => {
    const message = currentNode.message;
    const isGatherContext = message.tool_name === "gatherContext";

    if (!addIfFound.has(message.tool_call_id)) return;

    // Check if this tool_call_id has already been processed
    if (processedToolCallIds.has(message.tool_call_id)) {
        return;
    }

    // Validate that the most recent assistant message called this tool call ID
    if (!validateToolCallWasCalledByMostRecentAssistant(formattedMessages, message.tool_call_id)) {
        return;
    }

    // Mark this tool_call_id as processed
    processedToolCallIds.add(message.tool_call_id);

    let messageContent = '_';

    let formattedMessage: any = {
        role: "tool",
        content: messageContent,
        tool_call_id: message.tool_call_id,
        isGatherContext
    };
    const userMessageForToolEmulation: any = {
        role: "user",
        content: [],
        isTemp: true,
        isGatherContext
    };

    if (message.content.length !== 0) {
        const images = message.content.filter((item: any) => item.type === "image");
        if (images.length > 0) await addToolImageContent(userMessageForToolEmulation, images, provider);

        messageContent = message.content.filter((item: any) => item.type === "text")[0]?.text ?? '_';
    }
    formattedMessage.content = messageContent;

    formattedMessages.push(formattedMessage);

    if (userMessageForToolEmulation.content.length > 0) {
        formattedMessages.push(userMessageForToolEmulation);
    }
}
